import e from "../../utils/esm/generateUtilityClass/generateUtilityClass.js";
import r from "../../utils/esm/generateUtilityClasses/generateUtilityClasses.js";
function p(t) {
  return e("MuiPopper", t);
}
r("MuiPopper", ["root"]);
export {
  p as getPopperUtilityClass
};
